import { MenuItem, Stack, Typography } from "@mui/material";
import { RHFTextField } from "src/components/hook-form";
import useLocales from "src/hooks/useLocales";

const WEIGHT = ["BOLD", "REGULAR"];

const sxItem = {
	mx: 1,
	my: 0.5,
	borderRadius: 0.75,
	typography: "body2"
};

export default function WeightSelector() {
	const { translate } = useLocales();

	return (
		<Stack flexDirection={"row"} alignItems={"center"} justifyContent='space-between'>
			<Typography variant='body1' fontSize={14} color='text.secondary'>
				{translate("customization.text_style")}
			</Typography>
			<RHFTextField fullWidth select size='small' sx={{ width: 115 }} name={"buttonTextWeight"}>
				{WEIGHT.map((option, index) => (
					<MenuItem key={index} value={option} sx={sxItem}>
						{option}
					</MenuItem>
				))}
			</RHFTextField>
		</Stack>
	);
}
